<template>
  <aside class="min-w-15 border-r overflow-y-overlay overflow-x-hidden h-full">
    <slot />
  </aside>
</template>
